import React, { Component } from 'react'
import { Button, Popconfirm } from 'antd'
import cx from 'classnames'

import './IrreversibleButton.scss'

export default class IrreversibleButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
            visible: false
        }

        this.handleVisibleChange = this.handleVisibleChange.bind(this)
    }

    handleVisibleChange(visible) {
        const { disabled } = this.props

        if (disabled) {
            this.setState({ visible: false })
        } else {
            this.setState({ visible })
        }
    }

    render() {
        const { className, onConfirm, disabled, btnText } = this.props
        const { visible } = this.state

        return (
            <Popconfirm
            	visible={visible}
            	placement="bottom"
            	title="This action is irreversible, are you sure?"
            	onVisibleChange={this.handleVisibleChange}
                onConfirm={onConfirm}
            >
                <Button className={cx('IrreversibleButton', className, { disabled: disabled })} type="primary" size="large">{btnText}</Button>
        	</Popconfirm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/IrreversibleButton/IrreversibleButton.js